import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './index.scss';
import DropDownList from '../dropdown-list/index';
import SectionList from '../section-list/index';
import SectionDetail from '../section-detail/index';
import {
    curriculumTypeOptions
} from '../../helpers/utils';
import { COUNTRY_CURRICULUM_ID } from '../../constants';

const CurriculumList = ({
    countries,
    currentView,
    curriculumType,
    documents,
    handleCountryOnChange,
    handleDocumentOnChange,
    handleGoToListViewClick,
    handleOnSectionNameClick,
    handlePublicationOnChange,
    handleRegisterMasterCourse,
    handleCurriculumTypeOnChange,
    handleStateOnChange,
    onTreeDataChange,
    publications,
    sections,
    selectedCountry,
    selectedDocument,
    selectedPublication,
    selectedSectionDetail,
    selectedState,
    states
}) => {
    const listView = () => (
        <SectionList handleOnSectionNameClick={handleOnSectionNameClick} sections={sections} />
    );
    const detailView = () => (
        <SectionDetail
            handleGoToListViewClick={handleGoToListViewClick}
            handleRegisterMasterCourse={handleRegisterMasterCourse}
            onTreeDataChange={onTreeDataChange}
            sectionDetail={selectedSectionDetail} />
    );

    return (
        <div className={css.curriculumListComponent}>
            <div className={css.curriculumFilterComponent}>
                <DropDownList
                    name="curriculumType"
                    onChange={handleCurriculumTypeOnChange}
                    options={curriculumTypeOptions}
                    placeholder="Curriculum type"
                    value={curriculumType} />

                <DropDownList
                    name="countries"
                    disabled={curriculumType !== COUNTRY_CURRICULUM_ID}
                    onChange={handleCountryOnChange}
                    options={countries}
                    placeholder="Select a country"
                    value={selectedCountry} />

                <DropDownList
                    name="states"
                    disabled={curriculumType !== COUNTRY_CURRICULUM_ID}
                    onChange={handleStateOnChange}
                    options={states}
                    placeholder="Select a state"
                    value={selectedState} />

                <DropDownList
                    name="publications"
                    onChange={handlePublicationOnChange}
                    options={publications}
                    placeholder="Select a publication"
                    value={selectedPublication} />

                <DropDownList
                    name="documents"
                    onChange={handleDocumentOnChange}
                    options={documents}
                    placeholder="Select a document"
                    value={selectedDocument} />
            </div>
            { currentView === 'sectionList' ? listView() : detailView() }
        </div>
    );
};

CurriculumList.propTypes = {
    countries: PropTypes.array,
    currentView: PropTypes.string,
    documents: PropTypes.array,
    handleCountryOnChange: PropTypes.func,
    handleDocumentOnChange: PropTypes.func,
    handleGoToListViewClick: PropTypes.func,
    handleOnSectionNameClick: PropTypes.func,
    handlePublicationOnChange: PropTypes.func,
    handleRegisterMasterCourse: PropTypes.func,
    handleCurriculumTypeOnChange: PropTypes.func,
    handleStateOnChange: PropTypes.func,
    onTreeDataChange: PropTypes.func,
    publications: PropTypes.array,
    sections: PropTypes.array,
    selectedCountry: PropTypes.string,
    selectedDocument: PropTypes.string,
    selectedPublication: PropTypes.string,
    selectedSectionDetail: PropTypes.object,
    selectedState: PropTypes.string,
    states: PropTypes.array,
    curriculumType: PropTypes.string
};

export default styleable(css)(CurriculumList);



// WEBPACK FOOTER //
// ./app/components/curriculum-list/index.js